import React from 'react';
import Footer from '../Footer/Footer';

const About = () => {
    return (
        <>
               <div className="about_us_container">
                   
                     <div className="our_purpose">
                         <h1 className="text-white text-center heading">
                                 আমাদের উদ্দেশ্য
                         </h1>
                     </div>
                     <hr  className="my-5 m-auto  hr_line"  />
                     <div className="text_div">
                         <p className='text-muted'>
                         সকল প্রশংসা মহান আল্লাহর নামে যিনি আমাদেরকে আশরাফুল মাখলুকাত হিসেবে সৃষ্টি করে এ বিশ্ব ধরায় প্রেরণ করেছেন। দুরুদ ও সালাম জানাই বিশ্ব মানবতার মহান দূত, যিনি আল্লাহর পক্ষ থেকে পরিপূর্ণ জীবন ব্যবস্থা হিসেবে অবতীর্ণ ইসলামের শেষ এবং চুরান্ত রাসূল হিসেবে এ দুনিয়ায় আগমন করেছেন।  
                         <br />
                         <br />

কুরআন-হাদীসের ভাষ্য অনুযায়ী মানব প্রজন্ম রক্ষার সাথে সাথে চরিত্র রক্ষা ও মনের প্রশান্তিলাভও বিবাহের অন্যতম প্রধান উদ্দেশ্য। যে কোনো পক্ষে দ্বীনদারীর অভাব থাকলে এসব উদ্দেশ্যের সবটাই ঝুঁকিতে পড়ে যায়। 
                        <br />
                        <br />

আমরা গভীর দুঃখের সাথে লক্ষ্য করছি যে, বর্তমান সমাজে অনৈতিক সম্পর্ক, ব্যাভিচার, পরকীয়া ইত্যাদি সহজলভ্য ও মহামারীর ন্যায় ছড়িয়ে গিয়েছে কিন্তু পরিবার গঠনের সবচেয়ে গুরুত্বপূর্ণ মাধ্যম বিবাহ করা অত্যন্ত কঠিন হয়ে দাড়িয়েছে। ফলশ্রুতিতে সামাজিক অবক্ষয়ে সমাজ ভারাক্রান্ত।
                        <br />
                        <br />

আমরা আরো লক্ষ্য করেছি যে, যেসব ভাই-বোন পরিবারে দ্বীনি পরিবেশ না থাকা সত্ত্বেও কষ্ট করে দ্বীনের উপর অবিচল থাকার চেষ্টা করেন, তারা বিবাহের সময় প্রতিকূল পরিস্থিতিতে পড়েন। দেখা যায় যে, পরিবার পাত্র-পাত্রী নির্বাচনে দ্বীন ব্যতিত সব বিষয়কেই যথাযথ গুরুত্ব প্রদান করে, যেখানে শরিয়তে দ্বীন ব্যতিত সবই গৌণ।
                        <br />
                        <br />

এভাবে দ্বীনদার পাত্র-পাত্রীর সাথে বিবাহ না হলে, পরবর্তীতে বিবাহ পরবর্তী নতুন জীবনে নানাবিধ প্রতিকূলতার সম্মুখীন হওয়ার ঝুঁকিতে পড়েন। এতে দুনিয়ার শান্তি কিংবা দ্বীনের উপর অবিচলতা দুটোই হুমকির মুখে পড়ে যায়।
                        <br />
                        <br />

এমতাবস্থায় আমরা কজন গুনাহগার বান্দা মুসলিম ভাই-বোনদের বিবাহের বিধান পালনে সহায়তা করতে এ উদ্যোগ নিয়েছি, যার মাধ্যমে দ্বীনের ব্যাপারে উদাসীন পরিবারের ভাই-বোনেরা এই প্লাটফর্মের মাধ্যমে দ্বীনদার পাত্র-পাত্রী সন্ধানের ক্ষেত্রে সর্বোচ্চ সহায়তা পাবেন ইন শা আল্লাহ। পাশাপাশি ধর্মীয় পরিবেশে যারা বড় হয়েছেন তাদের ক্ষেত্রেও এ ওয়েবসাইট সহায়ক হিসেবে কাজ করবে। আমাদের লক্ষ্য হচ্ছে, এ ওয়েবসাইটের মাধ্যমে বিয়ের জন্য শরিয়ত সম্মত এক সার্বিক প্লাটফর্ম গড়ে তোলা যার মাধ্যমে বিবাহের পথ কিছুটা হলেও সহজ হয়ে যাবে ইনশাআল্লাহ।
                        <br />
                        <br />

আমরা আশা করছি যে, শরিয়াহ অনুসারে, অতি শীঘ্রই দেশব্যাপি এ খেদমত দক্ষতা ও দ্রুততার সাথে ছড়িয়ে দিতে পারবো। মহান আল্লাহ সুবহানাহু ওয়া তা’আলা আমাদের এ খেদমত কে সহজ করে দিন ও কবুল করুন। আমিন।

                         </p>
                        
                     </div>
                     <hr  className='my-5 m-auto hr_line ' />

                   
                   
                   
                   
                    <Footer />
                </div> 
        </>
    );
};

export default About;